module.exports = "dist/usa.png?ffbc2dba741019e84aec2cc52a5d751e";